module.exports = __webpack_public_path__ + "media/printed-materials/educators-02-marketing-handout-frontback-40886da9.jpg";